import { connect } from 'react-redux';
import MultiStepReactionDialog from '@Pages/RetroSynthesis/MultiStepReactionDialog/MultiStepReactionDialog';
import { isLoading, routeLayout, addProjectIsLoading } from './selectors';
import {
  fetchMultiStepReactionPreview,
  submitMultiStepReactionProject,
  submitSingleStepReactionProject,
  enrollMultiStepScheme,
  multiStepReactionDialogClearState,
} from './actions';

const mapStateToProps = (state) => ({
  isLoading: isLoading(state),
  routeLayout: routeLayout(state),
  addProjectIsLoading: addProjectIsLoading(state),
});

const mapDispatchToProps = {
  fetchMultiStepReactionPreview,
  submitMultiStepReactionProject,
  submitSingleStepReactionProject,
  enrollMultiStepScheme,
  multiStepReactionDialogClearState,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiStepReactionDialog);
